import { FunnelSimple, UserMinus } from "@phosphor-icons/react";
import clsx from "clsx";

import { ExcludeTargetsSettings } from "features/campaigns/components";

import ItemContainer from "common/components/CreateCampaignModal/CampaignSettings/ItemContainer";
import {
  dropdownMenuContentClassname,
  dropdownMenuListClassname,
} from "common/components/ui/DropdownMenu";
import FilterButton from "common/components/ui/FilterButton";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "common/components/ui/Popover";
import type { ExtraCampaignSettingsSchemaType } from "common/schemas";

interface ExtraSettingsProps {
  isDrip: boolean;
  settings: ExtraCampaignSettingsSchemaType;
  setSettings: (settings: ExtraCampaignSettingsSchemaType) => void;
}

export default function ExtraSettings({
  isDrip,
  settings,
  setSettings,
}: ExtraSettingsProps) {
  return (
    <ItemContainer
      icon={UserMinus}
      title="Exclude targets"
      description="Exclude targets based on campaign activity or profile details"
      isDrip={isDrip}
      infoText={
        isDrip &&
        "Drip campaigns always exclude targets that are in currently active campaigns"
      }
    >
      <Popover>
        <PopoverTrigger asChild>
          <FilterButton
            leftIcon={<FunnelSimple />}
            className="w-48 max-lg:ml-12.5"
          >
            Filters
          </FilterButton>
        </PopoverTrigger>
        <PopoverContent
          className={clsx(dropdownMenuContentClassname, "w-60")}
          align="end"
          side="top"
        >
          <div className={clsx(dropdownMenuListClassname, "justify-between")}>
            <ExcludeTargetsSettings
              settings={settings}
              setSettings={setSettings}
              isDrip={isDrip}
            />
          </div>
        </PopoverContent>
      </Popover>
    </ItemContainer>
  );
}
